import { ReactComponent as House } from '../../../assets/lineArt/line-art-house.svg';

export const LineArtMap = {
  house: { icon: House, viewBox: '0 0 72 35' },
} as const;

export type LineArtOption = keyof typeof LineArtMap;

export const LineArtOptions = Object.keys(LineArtMap) as LineArtOption[];
